import { Button } from 'components/Button'
import type { StrapiLink } from 'types/strapi/link'

export interface PostCtaProps {
  link: StrapiLink | null
}

export default function PostCta({ link }: PostCtaProps) {
  if (!link || !link?.url) return null

  return (
    <div className="mb-10 h-auto overflow-hidden rounded-lg bg-light-beige px-6 py-8">
      <Button variant="primary" href={link.url} className="mx-auto">
        {link.title}
      </Button>
    </div>
  )
}
